export default __webpack_public_path__ + "locales/fr/FillPDFDialog.json?hash=da6e8531d56d5cf7ae3ce88af7efe19e";